import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hotspot-mobile full-width"
}
const _hoisted_2 = {
  key: 0,
  class: "container mt-5"
}
const _hoisted_3 = {
  class: "swiper hotspot-mobile__swiper",
  ref: "mobileHotspot"
}
const _hoisted_4 = { class: "swiper-wrapper hotspot-mobile__wrapper" }
const _hoisted_5 = { class: "hotspot-mobile__content" }
const _hoisted_6 = { class: "hotspot-mobile__image-wrap" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "hotspot-mobile__content-wrap" }
const _hoisted_10 = { class: "hotspot-mobile__title" }
const _hoisted_11 = { class: "hotspot-mobile__description" }
const _hoisted_12 = {
  class: "hotspot-mobile__swiper-prev swiper-button-prev",
  ref: "prevButton"
}
const _hoisted_13 = {
  class: "hotspot-mobile__swiper-next swiper-button-next",
  ref: "nextButton"
}
const _hoisted_14 = {
  key: 1,
  class: "hotspot-mobile__loading-spinner"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.hotspotItems[0]?.MobileHotspotImage[0]?.Url)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($setup.titleLn!=0)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString($setup.title), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hotspotItems, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "swiper-slide hotspot-mobile__slide",
                key: item.Id
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (item?.MobileHotspotImage[0]?.Url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "hotspot-mobile__image",
                          src: item?.MobileHotspotImage[0]?.Url,
                          alt: item?.MobileHotspotImage[0]?.AlternativeText
                        }, null, 8 /* PROPS */, _hoisted_7))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: $setup.fallbackImage,
                          class: "hotspot-mobile__image",
                          alt: "No Hotspot Image Available"
                        }, null, 8 /* PROPS */, _hoisted_8))
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString($setup.getItemTitle(item)), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_11, _toDisplayString($setup.getItemDescription(item)), 1 /* TEXT */)
                  ])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_12, null, 512 /* NEED_PATCH */), [
            [_vShow, !$setup.hotspotsLoading]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_13, null, 512 /* NEED_PATCH */), [
            [_vShow, !$setup.hotspotsLoading]
          ])
        ], 512 /* NEED_PATCH */),
        ($setup.hotspotsLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}